import { List, ListItem, ListItemText, Paper, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';
import type { IIsPdf } from '../../models';
import { AvaniLightTheme } from '../../theme/schemes/AvaniLightTheme';
import { AvaniLineTitle } from '../DataDisplay';

export const Legend: FC<IIsPdf> = ({ isPDF = false }) => {
  const theme = isPDF ? AvaniLightTheme : useTheme();

  return (
    <Paper elevation={0} sx={{ padding: 2, display: 'block', backgroundColor: 'transparent' }} component={'div'}>
      <Typography variant="h2" sx={{ color: theme.colors.avani.teal }}>
        Line Condition
      </Typography>

      <Typography variant="body2" fontSize={18}>
        Colors A through D describe the pre-clean condition of the lines and give an indication of how the beers might
        have been performing prior to the ProClean.
      </Typography>

      <List sx={{ p: 0, py: 2 }}>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText
            primary={<AvaniLineTitle color={theme.colors.avani.aDarkPink} title={'Very Clean'} type={'A'} />}
            secondary={
              <Typography sx={{ display: 'block', marginTop: '8px' }} variant="body2" fontSize={16}>
                No organic material found in lines
              </Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText
            primary={<AvaniLineTitle color={theme.colors.avani.aPurple} title={'Good level of hygiene'} type={'B'} />}
            secondary={
              <Typography sx={{ display: 'block', marginTop: '8px' }} variant="body2" fontSize={16}>
                A small amount of organic material but nothing that will affect dispense.
              </Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText
            primary={<AvaniLineTitle color={theme.colors.avani.aGreen} title={'Some cleaning required'} type={'C'} />}
            secondary={
              <Typography sx={{ display: 'block', marginTop: '8px' }} variant="body2" fontSize={16}>
                Organic material found. Some products will normally be a "C" without affecting quality due to naturally
                higher levels of organic deposits. However, in some cases this can indicate the start of quality issues.
              </Typography>
            }
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <AvaniLineTitle
                color={theme.colors.avani.aYellow}
                title={'Contaminated line, Cleaning required'}
                type={'D'}
              />
            }
            secondary={
              <Typography sx={{ display: 'block', marginTop: '8px' }} variant="body2" fontSize={16}>
                A lot of organic material found. Regardless of the product, this result is undesirable. Lines that show
                a "D" are likely to have beer quality issues.
              </Typography>
            }
          />
        </ListItem>
      </List>
    </Paper>
  );
};
